
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/d/favorites",
      function () {
        return require("private-next-pages/d/favorites/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/d/favorites"])
      });
    }
  